/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `confirmed` - Confirmed
 * * `tentative` - Tentative
 * * `cancelled` - Cancelled
 * * `rejected` - Rejected
 */
export enum AvailabilityStatusEnum {
  CONFIRMED = 'confirmed',
  TENTATIVE = 'tentative',
  CANCELLED = 'cancelled',
  REJECTED = 'rejected',
}
